import React from 'react'
import PropTypes from 'prop-types'

import queryGraphql from '@shared/components/queryGraphql'
import { SERIES_ARCHIVE, SERIES_YEAR } from '@graphql/fixtures/fixtures.query'
import Error from '@shared/components/error'
import { GET_SEO_DATA } from '@graphql/article/article.query'
import { checkRedirectionStatus, getTimeZone, handleApiError } from '@shared-submodule/utils'
import { CURRENT_SERIES_LIST } from '@graphql/globalwidget/rankings.query'
import dynamic from 'next/dynamic'
const ArchiveContent = dynamic(() => import('@shared/components/archiveContent'))
const FixtureContent = dynamic(() => import('@shared/components/fixtureContent'))

const CricketSeriesArchive = ({ data, year, seoData, currentSeriesData }) => {
  return (
    <>
      <FixtureContent
        type="seriesArchive"
        currentSeriesData={currentSeriesData}
        seoData={{
          ...seoData
        }}
      >
        <ArchiveContent data={data} year={year} />
      </FixtureContent>
    </>
  )
}

CricketSeriesArchive.propTypes = {
  data: PropTypes.object,
  year: PropTypes.object,
  seoData: PropTypes.object,
  currentSeriesData: PropTypes.object
}

export default Error(CricketSeriesArchive)

export async function getServerSideProps({ res, resolvedUrl }) {
  try {
    res.setHeader('Cache-Control', 'public, max-age=420')

    const { allRoutes } = (await import('@shared-submodule/sm-constants/allRoutes'))
    const { data: seoData } = await queryGraphql(GET_SEO_DATA, { input: { sSlug: allRoutes.cricketSeriesArchive?.slice(1) } })
    // Check Redirection
    const { redirectStatus, eCode, returnObj, props } = checkRedirectionStatus(seoData?.getSeoData)
    if (redirectStatus && props) {
      res.statusCode = eCode
      return { props }
    } else if (redirectStatus) return returnObj
    const { data: currentSeriesData } = await queryGraphql(CURRENT_SERIES_LIST)
    const currentYear = new Date().getFullYear()
    const { data } = await queryGraphql(SERIES_ARCHIVE, { input: { eCategory: 'i', dYear: currentYear.toString(), sTimezone: getTimeZone(), nLimit: 20, nSkip: 1 } })
    const { data: year } = await queryGraphql(SERIES_YEAR)
    return {
      props: {
        data,
        year,
        seoData: seoData?.getSeoData,
        currentSeriesData: currentSeriesData
      }
    }
  } catch (e) {
    res.setHeader('Cache-Control', 'no-cache')
    const status = handleApiError(e, resolvedUrl)
    return status
  }
}
